// Converted from application/views/contacts_v.php. Edit this component directly.
export default function ContactsPage() {
  return <><h1>{"Contacts"}</h1>
<h3>{"For Informations or questions regarding Paddy Campbell and his work,"}<br />{" please email the studio."}</h3>
<div class={"row"}>
<div class={"column solo"}>
<div class={"calltoactionContainer"} style={{"backgroundImage":"url(/assets/images/contacts/studio.jpg)"}}>
<div class={"calltoactionWrp"}>
<a href={"mailto:ann@paddycampbell.ie?subject=Paddy%20Campbell%20Website%20Information"} target={"_blank"} rel="noopener noreferrer">{"\n                Contact the Studio\n            "}</a>
</div>
</div>
</div>
</div>
</>;
}
